import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';
import { Field, FieldType } from '../../../../../types/FieldCommon';
import { humanizeDate, humanizeTimestamp } from '../../../../../utility/dateUtils';

type Props = { field: Field };

export default function CustomFieldDisplay({ field }: Props) {
  const { label, type, value } = field;

  const formatted = (() => {
    if (_.isNil(value) || value === '') return '—';

    switch (type) {
      case FieldType.DATETIME:
        return humanizeTimestamp(String(value));
      case FieldType.DATE:
        return humanizeDate(String(value));
      case FieldType.TIME:
        return DateTime.fromISO(String(value)).toLocaleString(DateTime.TIME_SIMPLE);
      case FieldType.CHECKBOX:
        return value ? 'Yes' : 'No';
      case FieldType.MULTISELECT:
        return Array.isArray(value) ? value.join(', ') : '';
      default:
        return String(value);
    }
  })();

  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          whiteSpace: type === FieldType.MULTILINE ? 'pre-line' : 'normal',
          maxHeight: type === FieldType.MULTILINE ? 140 : 'auto',
          overflowY: type === FieldType.MULTILINE ? 'auto' : 'visible',
        }}
      >
        {formatted}
      </Typography>
    </Box>
  );
}
